import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "lang-switcher__round" }
const _hoisted_2 = { class: "lang-switcher__trigger-lang" }
const _hoisted_3 = { class: "lang-switcher__round" }
const _hoisted_4 = { class: "lang-switcher__name" }

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { setLocale } from '@/composition/useLangSet';
import { useClickOutside } from '@/libraries/useClickOutside';
import Dropdown from '@/components/Dropdown.vue';
import CleanButton from '@/components/CleanButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LangSwitcher',
  setup(__props) {

const router = useRouter();
const $el = ref<HTMLDivElement | null>(null);
const isShow = ref(false);
const { t } = useI18n();

const store = useStore();
const currentLang = computed(() => store.getters['Locales/currentSupportedLang']);
const supportedLocales = computed(() => store.getters['Locales/supportedLocales']);

const handleToggle = () => {
  isShow.value = !isShow.value;
};
const handleClose = () => {
  isShow.value = false;
};
const handleLangSelect = (lang: string) => {
  setLocale(lang);
  handleClose();
  router.go(0);
};

useClickOutside($el, handleClose);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "$el",
    ref: $el,
    class: "lang-switcher"
  }, [
    _createVNode(Dropdown, {
      show: isShow.value,
      indent: 0,
      right: "",
      class: "lang-switcher__dropdown"
    }, {
      trigger: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["lang-switcher__trigger nav-link__animated-bg", { active: isShow.value }]),
          onClick: handleToggle
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(`flag flag-${currentLang.value}`)
            }, null, 2)
          ]),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)(`languages['${currentLang.value}']`)), 1)
        ], 2)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supportedLocales.value, (lang) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: lang }, [
            (currentLang.value !== lang)
              ? (_openBlock(), _createBlock(CleanButton, {
                  key: 0,
                  class: "lang-switcher__dropdown-button",
                  disabled: currentLang.value === lang,
                  onClick: ($event: any) => (handleLangSelect(lang))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", {
                        class: _normalizeClass(`flag flag-${lang}`)
                      }, null, 2)
                    ]),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)(`languages['${lang}']`)), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["show"])
  ], 512))
}
}

})